import {
  APP_SHOW_LOADER,
  APP_HIDE_LOADER,
  OPEN_PROFILE_MODAL,
  CLOSE_PROFILE_MODAL,
  APP_SUCCESS_TOAST,
  APP_ERROR_TOAST,
  OPEN_GO_PREMIUM_MODAL,
  CLOSE_GO_PREMIUM_MODAL,
  APP_REFRESH_TOAST,
} from '../actions/meta.actions';

const initialState = {
  isMobileTablet: false,
  url: '',
  isPageLoading: false,
  query: {},
  isProfileModalOpen: false,
  toast: {
    type: '', // ['success', 'error']
    isShown: false,
    // showSuccessToast: false,
    // showErrorToast: false,
    message: '',
  },
  needToShowGoPremiumModal: false,
  isGoPremiumModalOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_SHOW_LOADER:
      return {
        ...state,
        isPageLoading: true,
      };
    case APP_HIDE_LOADER:
      return {
        ...state,
        isPageLoading: false,
      };
    case OPEN_PROFILE_MODAL:
      return {
        ...state,
        isProfileModalOpen: true,
      };
    case CLOSE_PROFILE_MODAL:
      return {
        ...state,
        isProfileModalOpen: false,
        // toast: {
        //   showSuccessToast: false,
        //   showErrorToast: false,
        //   message: ''
        // },
      };
    case APP_SUCCESS_TOAST:
      return {
        ...state,
        toast: {
          isShown: true,
          type: 'success',
          message: action.message,
        },
      };
    case APP_ERROR_TOAST:
      return {
        ...state,
        toast: {
          isShown: true,
          type: 'error',
          message: action.message,
        },
      };
    case APP_REFRESH_TOAST:
      return {
        ...state,
        toast: {
          isShown: false,
          type: '',
          message: '',
        },
      };
    case OPEN_GO_PREMIUM_MODAL:
      return {
        ...state,
        isGoPremiumModalOpen: true,
      };
    case CLOSE_GO_PREMIUM_MODAL:
      return {
        ...state,
        isGoPremiumModalOpen: false,
        toast: {
          showSuccessToast: false,
          showErrorToast: false,
          message: '',
        },
      };
    default:
      return state;
  }
};
